import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { IServiceItem } from './IServiceItem';
import { tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ServiceItemLookupService {
    constructor(
        @Inject(HttpClient) private http: HttpClient,
        @Inject(LoggingService) private log: LoggingService
    ) {}
    uri: string; // = `${environment.apiLocation}/ServiceItem`;

    public get(activeOnly: boolean = true): Observable<Array<IServiceItem>> {
        this.uri = `${environment.apiLocation}/ServiceItem?activeOnly=${activeOnly}`;
        this.log.verbose({
            type: 'ServiceItemLookupService:get',
            uri: this.uri // activeOnly ? `${this.uri}?activeOnly=${activeOnly}` : this.uri
        });
        return this.http.get<Array<IServiceItem>>(this.uri).pipe(
            tap(res =>
                this.log.verbose({
                    type: 'ServiceItemLookupService:get:reponse',
                    res
                })
            )
        );
    }
    public post(
        activeOnly: boolean = true,
        IncludeSystem: boolean = false,
        IncludeOtherChargeItem: boolean = false
    ): Observable<Array<IServiceItem>> {
        this.uri = `${environment.apiLocation}/ServiceItem`;
        this.log.verbose({
            type: 'ServiceItemLookupService:post',
            uri: this.uri, // activeOnly ? `${this.uri}?activeOnly=${activeOnly}` : this.uri
            activeOnly,
            IncludeSystem,
            IncludeOtherChargeItem
        });
        return this.http
            .post<Array<IServiceItem>>(this.uri, {
                activeOnly,
                IncludeSystem,
                IncludeOtherChargeItem
            })
            .pipe(
                tap(res =>
                    this.log.verbose({
                        type: 'ServiceItemLookupService:post:reponse',
                        res
                    })
                )
            );
    }
}
